import { render, staticRenderFns } from "./taxDetails.vue?vue&type=template&id=923c84fa"
import script from "./taxDetails.vue?vue&type=script&lang=js"
export * from "./taxDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports